module.exports = __webpack_public_path__ + "static/media/PAK.02ee3084.svg";